import { Fragment, ReactElement, ReactNode } from 'react'
import List from '@mui/material/List'
import MenuItem from '@mui/material/MenuItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import Typography from '@mui/material/Typography'
import Collapse from '@mui/material/Collapse'
import Tooltip from '@mui/material/Tooltip'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import classnames from 'classnames'
import ExpandMore from '@mui/icons-material/ExpandMore'
import ExpandLess from '@mui/icons-material/ExpandLess'
import { useTranslate, useSidebarState } from 'react-admin'

const useStyles = makeStyles((theme: Theme) => ({
  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    fontSize: 26,
    marginTop: 4,
    borderRadius: 6,
    fontFamily: 'Roboto, Regular',
    height: 30,
    color: '#a2a2a2',
    paddingRight: 0,
    '& .RaMenuItemLink-icon': {
      minWidth: 26,
    },
    // '& .MuiListItemIcon-icon':{
    //   minWidth: 26
    // }
  },
  // "You are here": the group that owns the current route, shown while the
  // sidebar is collapsed (icon rail) — when open, the active leaf link carries
  // the highlight and its group is already expanded.
  headerActive: {
    backgroundColor: '#F5F5F5',
    '& .MuiListItemIcon-root': {
      position: 'relative',
    },
  },
  headerText: {
    fontFamily: 'Roboto, Regular',
    fontSize: 13,
    fontWeight: 600,
    color: '#211F1F',
    flex: 1,
    paddingLeft: 12,
  },
  icon: {
    color: '#211F1F',
    width: 24,
    height: 24,
  },
  itemIcon: {
    // Same box react-admin gives leaf-link icons (24 + the text's 12 gap), so
    // header labels align with sibling leaf labels.
    minWidth: '24px !important',
  },
  list: {
    paddingLeft: 12,
    '& a': {
      transition: 'padding-left 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms',
      paddingLeft: theme.spacing(4),
      borderWidth: '7px',
    },
  },
}))

interface Props {
  dense: boolean
  handleToggle: () => void
  icon?: ReactElement | null
  isOpen: boolean
  name: string
  children: ReactNode
  hideExpand?: boolean
  inputStyle?: object
  rootStyle?: object
  /** Current route lives under this group. */
  active?: boolean
}

const SubMenu = (props: Props) => {
  const { handleToggle, isOpen, name, icon, children, dense, hideExpand, inputStyle, rootStyle, active } = props
  const translate = useTranslate()
  const classes = useStyles()
  const [open] = useSidebarState()

  const header = (
    //@ts-ignore
    // Label and arrow stay mounted when the sidebar is collapsed; the sidebar
    // clips them so they slide out sideways while the icon stays put.
    <MenuItem
      dense={dense}
      onClick={handleToggle}
      className={classnames(classes.header, !open && active && classes.headerActive)}
      style={rootStyle}
      aria-current={!open && active ? 'location' : undefined}
    >
      {!hideExpand && (
        <ListItemIcon classes={{ root: classes.itemIcon }}>
          {/* {isOpen ? <ExpandMore className={classes.icon} /> : icon} */}
          {icon}
        </ListItemIcon>
      )}
      <Typography variant="inherit" color="textSecondary" style={inputStyle} className={classes.headerText}>
        {translate(name)}
      </Typography>
      {isOpen ? <ExpandLess className={classes.icon} /> : <ExpandMore className={classes.icon} />}
    </MenuItem>
  )

  return (
    <Fragment>
      {open ? (
        header
      ) : (
        <Tooltip title={translate(name)} placement="right">
          {header}
        </Tooltip>
      )}
      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <List dense={dense} component="div" disablePadding className={classes.list}>
          {children}
        </List>
      </Collapse>
    </Fragment>
  )
}

export default SubMenu
